// React imports.
import React from "react";

// App imports.
import { AppPagesEnum } from "../state";
import Breadcrumbs from "./Breadcrumbs";
import {IGuidedSearchReportCategories, IGuidedSearchReport } from "../utility";



interface SelectReportProps {
     breadCrumbsCurrentStep: number;
     reportCategories: IGuidedSearchReportCategories[];
     reportSelectedHander: any;
}

function SelectReport({ breadCrumbsCurrentStep, reportCategories, reportSelectedHander }: SelectReportProps) {
     return (
          <React.Fragment>
               <Breadcrumbs currentStep={breadCrumbsCurrentStep} />
               <div className="accordion md-accordion" id="accordionEx" role="tablist" aria-multiselectable="true">
                    {reportCategories.map((category, index) => {
                         return (
                              <div className="card mt-3" key={index}>
                                   <div className="card-header" role="tab" id={"heading" + index}>
                                        <a data-toggle="collapse"
                                             data-parent="#accordionEx"
                                             href={"#collapse" + index}
                                             aria-expanded="true"
                                             aria-controls={"collapse" + index}
                                             title={ category.categoryToolTip}
                                        >
                                             <h5 className="mb-0">
                                                  <img className="icon"
                                                       src={"/data_warehouse/" + category.categoryIcon}
                                                       alt={"Icon for report category called" + category.categoryDesc}
                                                  />
                                                  {category.categoryDesc}
                                                  <i className="fas fa-angle-down rotate-icon"></i>
                                             </h5>
                                        </a>
                                   </div>
                                   <div id={"collapse" + index}
                                        className="collapse"
                                        role="tabpanel"
                                        aria-labelledby={"heading" + index}
                                        data-parent="#accordionEx">
                                        <div className="card-body">
                                             {category.reports.map(report => {
                                                  return (
                                                       <a className="report"
                                                            key={report.reportId}
                                                            href="#"
                                                            title={report.reportToolTip}
                                                            onClick={clickEvent => { clickEvent.preventDefault(); reportSelectedHander(report); } }                                                            >
                                                            <img className="icon"
                                                                 src={'/data_warehouse/' + report.graphIcon}
                                                                 alt={'Icon for a report titled ' + report.reportName } />
                                                            <span >{ report.reportName}</span>
                                                       </a>
                                                  )
                                             })}
                                        </div>
                                   </div>
                              </div>
                         )
                    })}
               </div>
          </React.Fragment >
     )
}

export default SelectReport;



